import { render, staticRenderFns } from "./TopCategories.vue?vue&type=template&id=a924e32e&"
import script from "./TopCategories.vue?vue&type=script&lang=js&"
export * from "./TopCategories.vue?vue&type=script&lang=js&"
import style0 from "./TopCategories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports